export const getDeclarations = (theme, backgroundType, customBackground) => {
    const colorsMap = {
        black: {
            normal: theme.colors.black,
            transparent: theme.colors.transparentBlack,
        },
        primary: {
            normal: theme.colors.primaryLight,
            transparent: theme.colors.transparentPrimaryLight,
        },
        primaryDark: {
            normal: theme.colors.primaryDark,
        },
        white: {
            normal: theme.colors.white,
            transparent: theme.colors.transparentWhite,
        },
    };
    const styles = {
        backgroudColor: "black",
        backgroundOpacity: "0.06",
    };
    if (backgroundType === "dark") {
        styles.backgroudColor = "primary";
        styles.backgroundOpacity = undefined;
    }
    if (backgroundType === "black") {
        styles.backgroudColor = "black";
        styles.backgroundOpacity = undefined;
    }
    const declarations = [];
    if (styles.backgroundOpacity && !customBackground) {
        declarations.push(`background-color: rgb(${colorsMap[styles.backgroudColor].transparent}, ${styles.backgroundOpacity});`);
    }
    else if (customBackground) {
        declarations.push(`background-color: ${customBackground};`);
    }
    else {
        declarations.push(`background-color: ${colorsMap[styles.backgroudColor].normal};`);
    }
    return declarations;
};
export const getBorderLayerDeclarations = (theme, backgroundType, state = undefined, customBackground) => {
    const colorsMap = {
        black: {
            normal: theme.colors.black,
            transparent: theme.colors.transparentBlack,
        },
        primary: {
            normal: theme.colors.primaryLight,
            transparent: theme.colors.transparentPrimaryLight,
        },
        primaryDark: {
            normal: theme.colors.primaryDark,
        },
        white: {
            normal: theme.colors.white,
            transparent: theme.colors.transparentWhite,
        },
    };
    const styles = {
        borderColor: "black",
        borderOpacity: "0",
    };
    if (backgroundType === "light") {
        if (state === "focused") {
            styles.borderColor = "primary";
            styles.borderOpacity = undefined;
        }
        if (state === "active") {
            styles.borderOpacity = undefined;
        }
    }
    if (backgroundType === "dark") {
        if (state === "focused") {
            styles.borderColor = customBackground ? "primary" : "primaryDark";
            styles.borderOpacity = undefined;
        }
        if (state === "active") {
            styles.borderOpacity = undefined;
        }
    }
    if (backgroundType === "black") {
        styles.borderColor = "black";
        styles.borderOpacity = "0";
        if (state === "focused") {
            styles.borderColor = "primary";
            styles.borderOpacity = undefined;
        }
        if (state === "active") {
            styles.borderColor = "white";
            styles.borderOpacity = undefined;
        }
    }
    const declarations = [];
    if (styles.borderOpacity) {
        declarations.push(`border: 1px solid rgb(${colorsMap[styles.borderColor].transparent}, ${styles.borderOpacity});`);
    }
    else {
        declarations.push(`border: 1px solid ${colorsMap[styles.borderColor].normal};`);
        if (state === "focused") {
            declarations.push(`outline: 1px solid ${colorsMap[styles.borderColor].normal};`);
        }
    }
    return declarations;
};
